<script>
  import { loggedInUserStore } from "../store/loggedInUser.js";
  import { langTextStore } from "../store/langtexts.js";
  import { push } from "svelte-spa-router";
  import { fade, fly } from "svelte/transition";
  import { tick } from "svelte";
  import LangSelector from "../SharedComponents/LangSelector.svelte";
  import { cubicOut, sineOut } from "svelte/easing";

  let transitionTime = 300;
  let transitionFactor = 3;
  async function seenTour() {
    await loggedInUserStore.seenTour();
    await tick();
    push("/");
  }
  async function hideTour() {
    await loggedInUserStore.hideTour();
    push("/");
  }
  let page = 1;

  function next() {
    let nextPage = page + 1;
    page = -1;
    setTimeout(() => (page = nextPage), transitionTime + 100);
  }

  function prev() {
    let nextPage = page - 1;
    page = -1;
    setTimeout(() => (page = nextPage), transitionTime + 100);
  }
</script>

<LangSelector
  extraClass="lang-switcher-dashboard"
  langs={$langTextStore.allLangs}
  showChoice={false}
  on:langChosen={() => {}}
/>
<div
  class="container tour align-vertical-middle "
  in:fly={{ delay: 200, y: 250, duration: 1600, easing: sineOut }}
  out:fade={{ duration: 200 }}
>
  <div in:fade={{ delay: 800 }}>
    <div class="row g-2 ">
      <div
        class="col-6 offset-md-1 col-md-4 offset-lg-2 col-lg-3 position-relative tour__slide "
      >
        <div class="h-100 pane bg-gray-8 p-4 text-center box-shadow">
          <img
          src="/img/logo.svg"
          class="w-75 mb-5 align-vertical-middle"
          alt={$langTextStore.getText("general-label-app-title")}
          title={$langTextStore.getText("general-label-app-title")}
        />
        </div>
        <div class="position-absolute bottom-0 w-100 text-center">
          <span
            on:click={hideTour}
            class="btn btn-white-outline width-unset mb-4"
            >{$langTextStore.getText("general-label-skip-tour")}</span
          >
        </div>
      </div>
      <div class="col-6   col-lg-5 position-relative">
        <div class="h-100  bg-white p-4 pane ">
          {#if page == 1}
            <div
              in:fade={{ duration: transitionTime * transitionFactor }}
              out:fade|local={{ duration: transitionTime }}
            >
              <h2 class="intro mt-0">
                {@html $langTextStore.getText("tour-page1-title")}
              </h2>
              {@html $langTextStore.getText("tour-page1-content")}
            </div>
          {/if}
          {#if page == 2}
            <div
              in:fade|local={{ duration: transitionTime * transitionFactor }}
              out:fade|local={{ duration: transitionTime }}
            >
              <h2 class="intro mt-0">
                {@html $langTextStore.getText("tour-page2-title")}
              </h2>
              {@html $langTextStore.getText("tour-page2-content")}
            </div>
          {/if}
          {#if page == 3}
            <div
              in:fade|local={{ duration: transitionTime * transitionFactor }}
              out:fade|local={{ duration: transitionTime }}
            >
              <h2 class="intro mt-0">
                {@html $langTextStore.getText("tour-page3-title")}
              </h2>
              {@html $langTextStore.getText("tour-page3-content")}
            </div>
          {/if}
          {#if page == 4}
            <div
              in:fade|local={{ duration: transitionTime * transitionFactor }}
              out:fade|local={{ duration: transitionTime }}
            >
              <h2 class="intro mt-0">
                {@html $langTextStore.getText("tour-page4-title")}
              </h2>
              {@html $langTextStore.getText("tour-page4-content")}
            </div>
          {/if}
          {#if page == 5}
            <div
              in:fade|local={{ duration: transitionTime * transitionFactor }}
              out:fade|local={{ duration: transitionTime }}
            >
              <h2 class="intro mt-0">
                {@html $langTextStore.getText("tour-pagethanks-title")}
              </h2>

              {@html $langTextStore.getText("tour-pagethanks-content")}
            </div>
          {/if}
        </div>
        <div class="position-absolute bottom-0 w-100 text-center">
          {#if page != 1}
            <button class="btn btn-gray w-25 mb-4" on:click={prev}>
              {$langTextStore.getText("general-label-prev")}
            </button>
          {:else}
            <button class="btn btn-gray w-25 mb-4" style="visibility:hidden" />
          {/if}
          {#if page == 5}
            <button class="btn btn-secondary w-25 mb-4" on:click={seenTour}
              >{$langTextStore.getText(
                "general-label-never-show-again"
              )}</button
            >
          {:else}
            <button class="btn btn-primary w-25 mb-4" on:click={next}
              >{$langTextStore.getText("general-label-next")}</button
            >
          {/if}
        </div>
      </div>
    </div>
    <div
      class="col-12 text-center mt-5"
      in:fade={{ delay: 1500, duration: 400 }}
    >
      <span
        class="dot"
        class:active={page == 1}
        on:click={() => {
          page = 1;
        }}
      />
      <span
        class="dot"
        class:active={page == 2}
        on:click={() => {
          page = 2;
        }}
      />
      <span
        class="dot"
        class:active={page == 3}
        on:click={() => {
          page = 3;
        }}
      />
      <span
        class="dot"
        class:active={page == 4}
        on:click={() => {
          page = 4;
        }}
      />
      <span
        class="dot"
        class:active={page == 5}
        on:click={() => {
          page = 5;
        }}
      />
    </div>
  </div>
</div>
<svelte:head>
  <style>
    .dot {
      cursor: pointer;
    }
    .lang-switcher-dashboard.lang-switcher .selector,
    .text-gray-5 {
      color: #fff;
    }
  </style>
</svelte:head>
